import React from 'react';
import { withStyles, WithStyles } from '@mui/styles';
import { Grid, Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import HTTP from 'services/http';
import { buildQaId } from 'utils/build-qa-id';
import { notifyError, notifySuccess } from 'actions/action-notifications';
import { FillDeliveryConfirmationStatus } from 'interfaces/enums/TaskStatuses/FillDeliveryConfirmationStatus';
import { dateFormat, getCustomerCurrentArborDate } from 'models/time/arbor-date';
import { ShippingStyles } from './shipping.styles';
import { IPickUpButton } from './types';
import { FDC, EDIT_FILL_DELIVERY_CONFIRMATION } from '../../constants/index';

const qaIdBuilder = buildQaId('shipping');

interface IShippingProps extends IPickUpButton, WithStyles<typeof ShippingStyles> {}

const MarkPickedUpButton = (props: IShippingProps): JSX.Element => {
  const { classes, currentFdcInformation, updateShippingPage = () => {} } = props;
  const [updating, setUpdating] = React.useState(false);
  const dispatch = useDispatch();

  const getMarkPickedUp = async () => {
    setUpdating(true);
    try {
      const updatedTask = {
        id: currentFdcInformation?.id,
        taskType: FDC,
        therapy_id: currentFdcInformation?.therapyId,
        status_id: FillDeliveryConfirmationStatus.PickedUp,
        picked_up_date: getCustomerCurrentArborDate().format(dateFormat),
      };
      const patchUrl = `/tasks/fdc/${updatedTask.id}`;
      const response = await HTTP.patch(patchUrl, updatedTask, {});
      const reduxPayload = {
        type: EDIT_FILL_DELIVERY_CONFIRMATION,
        payload: response,
      };
      dispatch(reduxPayload);
      dispatch(notifySuccess('FDC was successfully updated'));
      updateShippingPage();
    } catch (error) {
      dispatch(notifyError('Unable to mark order as picked up.'));
    } finally {
      setUpdating(false);
    }
  };

  return (
    <Grid item className={classes.printLabelButton}>
      <Button
        color="primary"
        variant="contained"
        onClick={async () => {
          return getMarkPickedUp();
        }}
        data-qa-id={qaIdBuilder('button.mark-picked-up')}
        disabled={updating}
      >
        {updating ? '....Processing' : 'Mark Picked Up'}
      </Button>
    </Grid>
  );
};

export default withStyles(ShippingStyles)(MarkPickedUpButton);
